// Generated by CoffeeScript 2.7.0
var BaseController, parseUrl;

import UrlHelper from 'helpers/url_helper.js';

({parseUrl} = UrlHelper);

export default BaseController = class BaseController {
  // super in mixed modules not supported
  static include(...modules) {
    return _.each(modules, (module) => {
      return _.extend(this.prototype, module);
    });
  }

  /*
  Run the new action for the create action.  Generally the create action will 'render :new' if there was a problem.
  This prevents doubling the code for each action.
  */
  create() {
    if (_.isFunction($currentController.new)) {
      return $currentController.new();
    }
  }

  /*
  Run the edit action for the update action.  Generally the update action will 'render :edit' if there was a problem.
  This prevents doubling the code for each action.
  */
  update() {
    if (_.isFunction($currentController.edit)) {
      return $currentController.edit();
    }
  }

  getParams() {
    var _, params;
    ({_, params} = parseUrl(window.location.href));
    return params;
  }

  getIds() {
    return window.location.pathname.match(/\d+/g);
  }

  getVars() {
    var ref;
    return (ref = window._page) != null ? ref.dig(arguments) : void 0;
  }

};
